import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';

const initialState = {
  meta: {},
  isAuthenticated: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setMe: (state, action) => {
      const payload = action.payload;

      if (payload.app_configs && payload.app_configs.subscription === 'SaaS') {
        const saasExpiryDate = moment(payload.app_configs.saas_expiry_date).format('yyyy-MM-DD');
        const today = moment().format('yyyy-MM-DD');

        if (moment(saasExpiryDate).diff(today, 'days') < 0) {
          localStorage.setItem('sass_expired', true);
        }
      }

      state.meta = payload.user;
      state.auths = payload.auths;
      state.current_auth = payload.current_auth;
      state.permissions = payload.permissions;
      state.esign_settings = payload.esign_settings;
      state.email_settings = payload.email_settings;
      state.security_settings = payload.settings;
      state.database_settings = payload.database_settings;
      state.app_configs = payload.app_configs;
      state.preferences = payload.preferences ? payload.preferences[0] : undefined;
      state.isAuthenticated = payload && payload.user_name && payload.user_name.length > 0;
    },
  },
});

export const { setMe } = authSlice.actions;

export default authSlice.reducer;